<!-- @deprecated Use modal-body-v2.vue instead. This component is kept for backwards compatibility. -->
<template>
  <div
    v-bind="{
      ...$attrs,
      class: 'w-full sm:w-fit',
    }"
    :class="{ 'h-full md:h-auto': mobileFullScreen }"
    data-modal-wrapper
  >
    <div class="relative" :class="{ 'mx-6': !mobileFullScreen }">
      <section
        class="m-auto p-6 bg-brand-bgdivider-20 backdrop-blur-3xl w-full overflow-y-auto"
        :class="[
          $attrs.class,
          {
            'max-desktop:h-dvh desktop:max-h-[calc(100dvh-2rem)] desktop:rounded-2xl':
              mobileFullScreen,
          },
          { 'max-h-[calc(100dvh-2rem)] rounded-2xl': !mobileFullScreen },
        ]"
      >
        <slot :is-open="isOpen" />
      </section>

      <slot name="actions">
        <header
          class="absolute top-0 right-0 translate-x-[40%] translate-y-[-40%] flex flex-row items-center gap-3 mb-2"
        >
          <button
            v-if="!hideCloseButton"
            class="btn btn-sm btn-circle p-2 w-auto h-auto bg-basics-bgdivider-10 text-brand-primary backdrop-blur-3xl border-0"
            v-bind="accessibilityButtonProps"
            @click="close"
          >
            <Icon icon="mdi:close" class="text-2xl" />
          </button>
        </header>
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * @deprecated Use modal-body-v2.vue instead. This component is kept for backwards compatibility.
 */
import { Icon } from "@iconify/vue";

defineOptions({
  inheritAttrs: false,
});

const emit = defineEmits<{
  close: [];
}>();

defineProps<{
  isOpen: boolean;
  hideCloseButton?: boolean;
  mobileFullScreen?: boolean;
}>();

const accessibilityButtonProps = {
  "data-dismiss": "modal",
  "aria-label": "Close",
};

const close = () => {
  emit("close");
};
</script>
